import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AiTaskListBlock } from '../../models/ai-assistant.models';

@Component({
  selector: 'app-response-task-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-task-list.component.html',
  styleUrl: './response-task-list.component.css',
})
export class ResponseTaskListComponent {
  @Input({ required: true }) block!: AiTaskListBlock;

  private expandedIds = new Set<string>();

  toggleExpand(taskId: string, event: Event): void {
    event.stopPropagation();
    if (this.expandedIds.has(taskId)) {
      this.expandedIds.delete(taskId);
    } else {
      this.expandedIds.add(taskId);
    }
  }

  isExpanded(taskId: string): boolean {
    return this.expandedIds.has(taskId);
  }

  openTask(task: AiTaskListBlock['tasks'][number]): void {
    const taskId = encodeURIComponent(task.routeTaskId || task.taskId);
    const href = task.routeActionItemId
      ? `/tasks/${taskId}/actionitem/${encodeURIComponent(task.routeActionItemId)}`
      : `/tasks/${taskId}`;
    window.open(href, '_blank', 'noopener,noreferrer');
  }

  getDomainInitials(domain: string): string {
    return domain
      .split(/[\s/_-]+/)
      .slice(0, 3)
      .map((w) => w[0]?.toUpperCase() ?? '')
      .join('');
  }

  formatDueDate(date: string): string {
    const d = new Date(date);
    if (isNaN(d.getTime())) return date;
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  getDueDateRelative(date: string): string {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const target = new Date(date);
    target.setHours(0, 0, 0, 0);
    const diff = Math.round((target.getTime() - now.getTime()) / 86400000);
    if (diff === 0) return 'Today';
    if (diff < 0) return `${Math.abs(diff)} day${Math.abs(diff) !== 1 ? 's' : ''} overdue`;
    return `In ${diff} day${diff !== 1 ? 's' : ''}`;
  }

  getDueDateClass(date: string): string {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const target = new Date(date);
    target.setHours(0, 0, 0, 0);
    const diff = Math.round((target.getTime() - now.getTime()) / 86400000);
    if (diff < 0) return 'due-overdue';
    if (diff <= 7) return 'due-urgent';
    return 'due-ok';
  }

  getInitials(name: string): string {
    return name
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((w) => w[0]?.toUpperCase() ?? '')
      .join('');
  }

  getProgressColor(pct: number): string {
    if (pct >= 70) return '#4ade80';
    if (pct >= 40) return '#fbbf24';
    return '#f87171';
  }

  badgeClass(value: string): string {
    return `tone-badge tone-${value.toLowerCase().replace(/\s+/g, '-')}`;
  }

}
